import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=469c3af2&"
import script from "./TransactionsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports